import request from '@/utils/request';

/**
 * 商户 列表（平台端功能）
 */
export function merchantListApi(params) {
  return request({
    url: '/admin/platform/merchant/list',
    method: 'get',
    params: params
  });
}

/**
 * 商户分类 全部列表
 */
export function merchantCategoryAllListApi() {
  return request({
    url: '/admin/merchant/category/all/list',
    method: 'get'
  });
}

/**
 * 店铺类型 全部列表
 */
export function merchantTypeAllListApi() {
  return request({
    url: '/admin/merchant/type/all/list',
    method: 'get'
  });
}

/**
 * @description 商户基本设置 -- 商户详情
 */
export function getBaseInfoApi() {
  return request({
    url: '/admin/merchant/base/info',
    method: 'get'
  });
}

/**
 * @description 商户基本设置 -- 提交
 */
export function merchantUpdateApi(data) {
  return request({
    url: '/admin/merchant/config/info/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户基本设置 -- 配置信息
 */
export function merchantConfigInfoApi() {
  return request({
    url: '/admin/merchant/config/info',
    method: 'get'
  });
}

/**
 * @description 商户基本设置 -- 商户开关
 */
export function merchantSwitchApi() {
  return request({
    url: '/admin/merchant/switch/update',
    method: 'post'
  });
}

/**
 * @description 商户基本设置 -- 转账信息
 */
export function merchantTransferApi() {
  return request({
    url: '/admin/merchant/settlement/info',
    method: 'GET'
  });
}

/**
 * @description 商户基本设置 -- 转账信息编辑
 */
export function merchantTransferEditApi(data) {
  return request({
    url: '/admin/merchant/settlement/info/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description 获取商户端商户商品审核开关信息
 */
export function productAuditSwitchInfoApi() {
  return request({
    url: '/admin/merchant/product/audit/switch/info',
    method: 'get'
  });
}
// /**
//  * 商户 权限规则菜单列表
//  * @param pram
//  */
// export function menuMerListApi(params) {
//   const data = {
//     menuType: params.menuType, //菜单类型:M-目录，C-菜单，A-按钮
//     name: params.name, //菜单名称
//   };
//   return request({
//     url: `/admin/merchant/menu/list`,
//     method: 'get',
//     params: data,
//   });
// }

// /**
//  * 商户 权限规则新增菜单
//  * @param data
//  */
// export function menuMerAdd(data) {
//   let systemMenuRequest = data;
//   return request({
//     url: `/admin/merchant/menu/add`,
//     method: 'post',
//     data: systemMenuRequest,
//   });
// }

// /**
//  * 商户 权限规则删除菜单
//  * @param data
//  */
// export function menuMerDelete(id) {
//   return request({
//     url: `/admin/merchant/menu/delete/${id}`,
//     method: 'post',
//   });
// }

// /**
//  * 商户 权限规则菜单详情
//  * @param data
//  */
// export function menuMerInfo(id) {
//   return request({
//     url: `/admin/merchant/menu/info/${id}`,
//     method: 'get',
//   });
// }

// /**
//  * 商户 权限规则菜单修改
//  * @param data
//  */
// export function menuMerUpdate(data) {
//   let systemMenuRequest = data;
//   return request({
//     url: `/admin/merchant/menu/update`,
//     method: 'post',
//     data: systemMenuRequest,
//   });
// }

// /**
//  * 权限规则修改菜单显示状态
//  * @param data
//  */
// export function menuMerUpdateShowStatus(params) {
//   return request({
//     url: `/admin/merchant/menu/update/show/${params.id}`,
//     method: 'post',
//   });
// }
// 3.23 befor

/**
 * 商户 权限规则菜单列表
 * @param pram
 */
export function menuMerListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name //菜单名称
  };
  return request({
    url: "/admin/platform/merchant/menu/list",
    method: 'get',
    params: data
  });
}

/**
 * 商户 权限规则新增菜单
 * @param data
 */
export function menuMerAdd(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/platform/merchant/menu/add",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 商户 权限规则删除菜单
 * @param data
 */
export function menuMerDelete(id) {
  return request({
    url: "/admin/platform/merchant/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 商户 权限规则菜单详情
 * @param data
 */
export function menuMerInfo(id) {
  return request({
    url: "/admin/platform/merchant/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 商户 权限规则菜单修改
 * @param data
 */
export function menuMerUpdate(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/platform/merchant/menu/update",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则修改菜单显示状态
 * @param data
 */
export function menuMerUpdateShowStatus(params) {
  return request({
    url: "/admin/platform/merchant/menu/update/show/".concat(params.id),
    method: 'post'
  });
}